import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import * as pageActions from '../../actions/Page';
import Navbar from './Navbar';
import logoUrl from '../../content/images/logo.png';
import './TopMenu.scss';

class TopMenu extends Component {
   
    onCreateComplaintClick = () => this.props.changePageToCreateComplaint();
    onHomeBtnClick = () => this.props.changePageToStartPage();
    onPreviewComplaintClick = () => this.props.changePageToSearchComplaint();
   
    render(){
       return(
            <Navbar
                onCreateComplaintClick={this.onCreateComplaintClick}
                onHomeBtnClick={this.onHomeBtnClick}
                onPreviewComplaintClick={this.onPreviewComplaintClick}
                logoUrl={logoUrl}/>
       );
   }
}

const mapStateToProps = (state) => {
    return {
        texts: state.texts.texts
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        changePageToCreateComplaint: () => dispatch(pageActions.changePageToCreateComplaint()),
        changePageToSearchComplaint: () => dispatch(pageActions.changePageToSearchComplaint()),
        changePageToStartPage: () => dispatch(pageActions.changePageToStartPage())
    };
};

TopMenu.propTypes = {
    changePageToCreateComplaint: PropTypes.func,
    changePageToSearchComplaint: PropTypes.func,
    changePageToStartPage: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopMenu);


// WEBPACK FOOTER //
// ./src/components/TopMenu/TopMenu.js